import { j as H } from "../../../../jsx-runtime.BREq8dyb.js";
import { memo as L, useRef as _, useState as e, useEffect as n } from "react";
import "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import { DEFAULT_FILE_HAS_HEADER as R, DEFAULT_FILE_VALUES_DELIMITER as E, DEFAULT_FILE_DECIMAL_SEPARATOR as S, DEFAULT_FILE_HEADERS as t, FileProvider as I } from "../../contexts/FileContext/FileContext.js";
import "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import { useSchema as T } from "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import "../../contexts/WorkerContext/WorkerContext.js";
const v = L(({
  children: c
}) => {
  const {
    schema: F
  } = T(), r = _(F === void 0 ? !0 : R), [o, p] = e(void 0), [d, f] = e(void 0), [s, a] = e(r.current), [l, m] = e(E), [{
    decimal: u
  }, A] = e({
    decimal: S
  }), [D, i] = e(t);
  return n(() => {
    a(r.current), m(E), i(t);
  }, [o]), n(() => {
    i(t);
  }, [s, l]), /* @__PURE__ */ H.jsx(I, { value: {
    file: o,
    fileDecimalSeparator: u,
    fileEncoding: d,
    fileHasHeader: s,
    fileHeaders: D,
    fileValuesDelimiter: l,
    setFile: p,
    setFileEncoding: f,
    setFileHasHeader: a,
    setFileHeaders: i,
    setFileSeparators: A,
    setFileValuesDelimiter: m
  }, children: c });
});
v.displayName = "FileContainer";
export {
  v as default
};
//# sourceMappingURL=FileContainer.js.map
